<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  logs: {
    type: Array,
    default: () => [],
  },
});

const { t } = useI18n();

const STATUS_CLASS = {
  imported: 'bg-green-100 text-green-700',
  skipped: 'bg-yellow-100 text-yellow-700',
  failed: 'bg-red-100 text-red-700',
  duplicate: 'bg-n-slate-100 text-n-slate-600',
  pending: 'bg-n-slate-100 text-n-slate-600',
};
</script>

<template>
  <div>
    <p
      v-if="logs.length === 0"
      class="py-4 text-center text-sm text-n-slate-11"
    >
      {{ t('FACEBOOK_IMPORT.LOG.EMPTY') }}
    </p>
    <table v-else class="w-full text-xs">
      <thead>
        <tr class="border-b border-n-weak text-left text-n-slate-11">
          <th class="py-2 pr-3">{{ t('FACEBOOK_IMPORT.LOG.CONTACT') }}</th>
          <th class="py-2 pr-3">{{ t('FACEBOOK_IMPORT.LOG.MESSAGES') }}</th>
          <th class="py-2 pr-3">{{ t('FACEBOOK_IMPORT.LOG.STATUS') }}</th>
          <th class="py-2">{{ t('FACEBOOK_IMPORT.LOG.ERROR') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="log in logs"
          :key="log.id"
          class="border-b border-n-weak hover:bg-n-slate-2"
        >
          <td class="py-1.5 pr-3 text-n-slate-12">
            {{ log.contact_name || '—' }}
          </td>
          <td class="py-1.5 pr-3 text-n-slate-11">
            {{ log.messages_imported }}
          </td>
          <td class="py-1.5 pr-3">
            <span
              class="rounded px-1.5 py-0.5 text-xs"
              :class="STATUS_CLASS[log.status]"
            >
              {{ log.status }}
            </span>
          </td>
          <td class="py-1.5 text-n-slate-11">
            {{ log.error_message || log.skip_reason || '—' }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
